<!-- 自主产品FCST业务蓝图 -->

<template>
  <div class="FCST_business_box"
    :class="{ 'FCST_business_engbox': $i18n.locale === 'en_US', 'FCST_business_ja_box': $i18n.locale === 'ja_JP' }">


    <div class="FCST_business_content">
      <div class="sheet_content" :style="{
        'background-image': 'url(' + sheetBgSrc + ')', backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center'
      }">

        <div class="text_title_lg title">{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.title') }}
        </div>
        <div class="text_title_lg title width1" style="left: 41rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box02.title') }}</div>
        <div class="text_title_lg title width2" style="left: 83rem">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box03.title') }}</div>
        <div class="text_title_lg title width3" style="left: 116.4rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box04.title') }}</div>
        <div class="text_title_lg width1 text-center" style="top: 7.2rem;left: 41rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box02.subtitle') }}</div>
        <div class="text_title_lg width2 text-center" style="top: 7.2rem;left: 83rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box03.subtitle') }}</div>

        <div class="text_title_sm width4 text-center" style="top: 9.6rem; left: 2rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card01.title') }}</div>
        <div class="text_normal" style="top: 13rem;left: -1.6rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card01.text01') }}</span>
        </div>
        <div class="text_normal" style="top: 13rem;left: 12rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card01.text03') }}</span>
        </div>
        <div class="text_normal" style="top: 16rem;left: 0.7rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card01.text02') }}</span>
        </div>
        <div class="text_title_sm width5 text-center" style="top: 23.3rem; left: 2rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card02.title') }}</div>
        <div class="text_normal" style="top: 27rem;left: -3.5rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card02.text01') }}</span>
        </div>
        <div class="text_normal" style="top: 30rem;left: -3.4rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card02.text02') }}</span>
        </div>

        <div class="text_title_sm width5 text-center" style="top: 23.3rem; left: 18.5rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card03.title') }}</div>
        <div class="text_normal" style="top: 27rem;left: 13rem;display: flex;flex-direction: row;">
          <span class="purple_circle" style="margin-top: -2.7rem;"></span>
          <span style="display: inline-block; width: 10rem;text-align: center;">{{
            this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card03.text') }}</span>
        </div>

        <div class="text_title_sm width4 text-center" style="top: 37.5rem; left: 2rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card04.title') }}</div>
        <div class="text_normal" style="top: 41.5rem;left: 5rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card04.text') }}</span>
        </div>

        <div class="text_title_sm width5 text-center" style="top: 49rem; left: 2rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card05.title') }}</div>
        <div class="text_normal" style="top: 52.9rem;left: -3rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card05.text') }}</span>
        </div>

        <div class="text_title_sm width5 text-center" style="top: 49rem; left: 18.5rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card06.title') }}</div>
        <div class="text_normal" style="top: 52.9rem;left: 13.5rem;">
          <span class="purple_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box01.card06.text') }}</span>
        </div>

        <div class="text_title_sm width1 text-center" style="top: 13.7rem; left: 41rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card01.title') }}</div>
        <div class="text_normal" style="top: 17.8rem;left: 45rem;">
          <span class="red_circle" style="margin-top: -2rem;margin-right: 0.2rem;"></span>
          <span style="display: inline-block; width: 25rem;text-align: center;">{{
            this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card01.text') }}</span>
        </div>

        <div class="text_title_sm width1 text-center" style="top: 31.5rem; left: 41rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card02.title') }}</div>
        <div class="text_normal" style="top: 35rem;width: 175px;"
          :style="{ 'left': $i18n.locale === 'en_US' ? '41.5rem' : '43.5rem' }">
          <span class="red_circle"></span>
          <span style="width: 165px;" class="text_1">{{
            this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card02.text01') }}</span>
        </div>
        <div class="text_normal" style="top: 35rem;left: 58.4rem;width: 175px;">
          <span class="red_circle" style=""></span>
          <span style="width: 165px;" class="text_2">{{
            this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card02.text02') }}</span>
        </div>
        <div class="text_normal width1 text_normal_1" style="top: 39rem;"
          :style="{ 'left': $i18n.locale === 'en_US' ? '41.5rem' : '43.5rem' }">
          <span class="red_circle"></span>
          <span style="width: 165px;">{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card02.text03')
          }}</span>
        </div>

        <div class="text_title_sm width1 text-center" style="top: 48.8rem; left: 41rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card03.title') }}</div>
        <div class="text_normal" style="top: 53rem;left: 45.3rem;">
          <span class="red_circle"></span>
          <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box02.card03.text') }}</span>
        </div>

        <div class="text_title_sm width2 text-center" style="top: 13.7rem; left: 83rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box03.card01.title') }}</div>
        <div class="text_normal" style="top: 17.8rem;left: 84.2rem;">
          <span class="green_circle" style="margin-top: -2rem;margin-right: -1.7rem;"></span>
          <span style="display: inline-block; width: 25rem;text-align: center;">{{
            this.$t('product.VyungFCST.business_blueprint.base_setup.box03.card01.text') }}</span>
        </div>

        <div class="text_title_sm width2 text-center" style="top: 32.9rem; left: 83rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box03.card02.title') }}</div>
        <div class="text_normal" :style="{ 'top': `${$i18n.locale === 'ja_JP' ? '36rem' : '36.8rem'}`, 'left': `${$i18n.locale === 'ja_JP' ? '83rem' : '83.5rem'}` }">
          <span class="green_circle"></span>
          <span class="text_3">{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box03.card02.text') }}</span>
        </div>

        <div class="text_title_sm width2 text-center" style="top: 49.3rem; left: 83rem;">{{
          this.$t('product.VyungFCST.business_blueprint.base_setup.box03.card03.title') }}</div>
      <div class="text_normal" style="top: 52.8rem;left: 83.4rem;">
        <span class="green_circle"></span>
        <span>{{ this.$t('product.VyungFCST.business_blueprint.base_setup.box03.card03.text') }}</span>
      </div>

      <div class="text_title_sm width3 text-center" style="top: 34rem; left: 116.3rem;">{{
        this.$t('product.VyungFCST.business_blueprint.base_setup.box04.text') }}</div>

    </div>
  </div>
</div></template>

<script>

export default {
  name: 'FCSTBusinessBlueprint',
  data () {
    return {
      sheetBgSrc: require('../../../../assets/images/ProductService/VyungFCST/business_sheet_bg.png')
    }

  }
}
</script>